// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"2504488c","502":"033d0e0c","818":"bca1c61d","853":"81799bb2","872":"8138c780","946":"fe956758"}[chunkId] + ".chunk.js";
};